var _react_refresh_temp_1;
_react_refresh_temp_1 = $RefreshSig$();
// '#context' is imported by direct path: its barrel would close the context <-> query-hooks cycle (see CLAUDE.md).
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { getRootLogger } from '@lucidlink/tscore';
import { useUserClient } from '@lucidlink/uicore';
import { broadcastMessage } from '#context/BroadcastChannel';
import { useLucidSdk } from '#context/LucidSdk/useLucidSdk';
import { useCurrentProfile } from '../../queries/account/useCurrentProfile';
import { CurrentProfileKeyFactory } from '../../query-key-factories';
export const useLogOut = ({ onError, onSettled, onSuccess, shouldBroadcast = true } = {
    shouldBroadcast: true,
}) => {
    _react_refresh_temp_1();
    const { lucidSdk } = useLucidSdk();
    const { windowId } = useUserClient();
    const queryClient = useQueryClient();
    const { query: { data: currentProfile }, } = useCurrentProfile({});
    const mutation = useMutation({
        mutationFn: async () => {
            await lucidSdk.authenticationClient().logout();
        },
        onError: (e) => {
            if (typeof onError === 'function') {
                onError();
            }
            getRootLogger().error({ err: e, email: currentProfile?.email }, 'Logout failed');
        },
        onSettled: () => {
            if (typeof onSettled === 'function') {
                onSettled();
            }
        },
        onSuccess: async () => {
            getRootLogger().info({ email: currentProfile?.email }, 'User logged out');
            await queryClient.resetQueries({
                queryKey: CurrentProfileKeyFactory.exact(),
                exact: true,
            });
            queryClient.clear();
            if (shouldBroadcast) {
                broadcastMessage({
                    type: 'logout',
                    payload: {
                        windowId,
                    },
                });
            }
            if (typeof onSuccess === 'function') {
                onSuccess();
            }
        },
        networkMode: 'always',
    });
    return {
        mutation,
    };
};
_react_refresh_temp_1(useLogOut, "QdBkfYrl9zEA11SjqeE88kzzKPI=", false, () => [useLucidSdk, useUserClient, useQueryClient, useCurrentProfile, useMutation]);
